/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AutocompleteAddress/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import AutocompleteAddressChoice from 'DesignSystem/AutocompleteAddressChoice/index'
import InputText from 'DesignSystem/InputText/index'
import React from 'react'
import Shortcut from 'DesignSystem/Shortcut/react'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function AutocompleteAddress({
  children,
  viewPath = "/DesignSystem/AutocompleteAddress",
  autoFocus,
  fontSize,
  onBlur,
  onChange,
  onSubmit,
  isInvalid,
  value,
  label,
  width = "auto",
  isShowingSuggestions,
  from,
  paddingLeft = 0,
  paddingRight = 0,
  chooseAddress,
  selected,
  prevSuggestion,
  nextSuggestion,
  chooseSelectedAddress,
  closeSuggestions
  
}) {
  let isMedia = useIsMedia()
  return (<React.Fragment
>
<div
  data-testid="AutocompleteAddress.AutocompleteAddress:1"
  data-view-path={viewPath}
 className="views-block"
>
<InputText
  viewPath={`${viewPath}/InputText`}
 autoComplete="off"
 autoFocus={autoFocus}
 fontSize={fontSize}
 className="mousetrap"
 onBlur={onBlur}
 onChange={onChange}
 onSubmit={onSubmit}
 isInvalid={isInvalid}
 placeholder="Street"
 type="text"
 value={value}
 label={label}
 width={width}
 className="mousetrap"
/>
<fromFlow.When is={isShowingSuggestions}>
<div
  data-testid="AutocompleteAddress.AutocompletePopup"
  data-view-path={viewPath}
 className={`views-block ${styles.AutocompletePopup}`}
>
<div
  data-testid="AutocompleteAddress.List"
  data-view-path={viewPath}
 style={{'--pl-1-2wQ0Ii': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-2-2wQ0Ii': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--w-3-2wQ0Ii': isMedia.mobile ? "350px" : "600px"}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(from) && from.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="autocomplete_address_choice"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/AutocompleteAddressChoice(${item?.id ?? item?._id ?? index})`}
      >
<AutocompleteAddressChoice
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/AutocompleteAddressChoice(${item?.id ?? item?._id ?? index})`}
 onClick={chooseAddress}
 selected={selected}
/>
</ListItem>
)}
</div>
<Shortcut
  viewPath={`${viewPath}/Shortcut`}
 keys="up"
 onPress={prevSuggestion}
/>
<Shortcut
  viewPath={`${viewPath}/Shortcut`}
 keys="down"
 onPress={nextSuggestion}
/>
<Shortcut
  viewPath={`${viewPath}/Shortcut`}
 keys="enter"
 onPress={chooseSelectedAddress}
/>
<Shortcut
  viewPath={`${viewPath}/Shortcut`}
 keys="esc"
 onPress={closeSuggestions}
/>
</div>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }